import { useNavigate } from "react-router-dom";

import logoImage from "../img/granhand_logo.png";

// 스토어(Google Play) 계정 삭제 안내 — 로그인 없이 볼 수 있어야 한다.
// 보관 기간은 앱 탈퇴 안내(DropoutScreen)·개인정보처리방침(policies.js)과 맞춘다.
const DELETED = [
  "회원 정보(이름, 이메일, 휴대폰 번호, 생년월일, 성별): 탈퇴 후 3개월 뒤 삭제",
  "회원 등급, 적립금, 쿠폰: 탈퇴 즉시 영구 삭제",
  "배송지, 알림 설정 등 서비스 이용 정보: 탈퇴 즉시 삭제",
];

const RETAINED = [
  "계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래법)",
  "대금 결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래법)",
  "소비자 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래법)",
  "본인확인 정보(DI, 중복 혜택 방지): 1년",
  "접속 로그: 3개월 (통신비밀보호법)",
];

const Section = ({ title, items }) => (
  <div className="signup-auth__summary">
    <p className="signup-auth__summary-title">{title}</p>
    {items.map((text) => (
      <p key={text} className="signup-auth__summary-desc">
        · {text}
      </p>
    ))}
  </div>
);

export default function AccountDeletion() {
  const nav = useNavigate();

  return (
    <main className="signup-auth container">
      <div className="signup-auth__frame">
        <div className="signup-auth__brand">
          <img alt="GRANHAND." src={logoImage} />
        </div>
        <div className="signup-auth__content">
          <section className="signup-auth__step">
            <div className="signup-auth__summary">
              <p className="signup-auth__summary-title">
                그랑핸드(GRANHAND) 계정 삭제 안내
              </p>
              <p className="signup-auth__summary-desc">
                그랑핸드 앱 또는 웹에서 회원 탈퇴를 하면 계정과 관련 데이터가
                삭제됩니다.
              </p>
            </div>

            <Section
              title="앱에서 삭제하기"
              items={["그랑핸드 앱 로그인 → MY → 회원정보 관리 → 회원탈퇴"]}
            />
            <Section
              title="웹에서 삭제하기"
              items={[
                "아래 버튼으로 로그인 → 마이페이지 → 회원탈퇴",
                "앱·웹을 이용할 수 없는 경우 앱 내 고객센터(채널톡)로 가입 이메일과 함께 삭제를 요청해 주세요.",
              ]}
            />
            <Section title="삭제되는 데이터" items={DELETED} />
            <Section
              title="관련 법령에 따라 보관되는 데이터 (기간 경과 후 파기)"
              items={RETAINED}
            />

            <button
              type="button"
              className="signup-auth__submit"
              onClick={() => nav("/drop-out")}
            >
              로그인하고 회원탈퇴 하기
            </button>

            <div className="signup-auth__summary">
              <p className="signup-auth__summary-title">
                Account deletion (GRANHAND)
              </p>
              <p className="signup-auth__summary-desc">
                In the GRANHAND app: MY → 회원정보 관리 (Account) → 회원탈퇴
                (Delete account). On the web: sign in with the button above → My
                page → Delete account. Profile data is deleted 3 months after
                deletion; points and coupons are deleted immediately. Order and
                payment records are kept for 5 years and dispute records for 3
                years as required by Korean e-commerce law, then destroyed.
              </p>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
}
